export default __webpack_public_path__ + "static/media/defispot-logo.af8d4a7b.svg";